export default __webpack_public_path__ + "static/media/oneid-small-uk-passport.93d965b7.jpg";